import React from 'react';
import { Header } from './components/Header/Header';
import MainProvider from './context/Main.context';
import { FormPage } from './pages/FormPage/FormPage';

const App = () => {
  return (
    <MainProvider>
      <Header />
      <FormPage />
    </MainProvider>
  );
}

export default App;
